import { CanDeactivateFn } from '@angular/router';
import type { RemoteSupportComponent } from 'app/modules/area-trabalho/remote-support/remote-support.component';

/** Asks the remote support page whether the technician may leave it (see `confirmLeave`). */
export const remoteSupportLeaveGuard: CanDeactivateFn<
  RemoteSupportComponent
> = (component) => component.confirmLeave();
